<template>
  <header class="pt2 sm-px2 pb2 md-flex md-fixed sm-pt2 top-0 left-0 col-12 bg-white z1">
    <div class="sidebar">
      <router-link to="/">
        <h1 v-text="title" class="inline-block m0 h4 regular py1 px2 sm-pt2"></h1>
      </router-link>
    </div>
    <div class="sm-flex-auto ml1">
      <ul :class="{ 'fade-enter pe-none': !imgReady && !ready }" class="list-reset line-height-3 m0 fade-enter-active">
        <li class="inline-block">
          <router-link to="/" exact active-class="nope" :class="{'router-link-active': showSub && ready}" class="pl1 sm-py2 inline-block">
            <span>Work</span>
          </router-link>
        </li>
        <li class="inline-block">
          <router-link to="/desk" exact class="pl1 sm-py2 inline-block">
            <span>Journal</span>
          </router-link>
        </li>
        <li class="inline-block">
          <router-link to="/contact" exact class="pl1 sm-py2 inline-block">
            <span>Contact</span>
          </router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import { mapState } from 'vuex'

  const submenuRoutes = ['commissions', 'commission', 'projects', 'project']
  const workRoutes = ['commissions', 'commission']

  export default {
    name: 'app-header',
    computed: {
      showSub () {
        return submenuRoutes.indexOf(this.$route.name) > -1
      },
      worksActive () {
        return workRoutes.indexOf(this.$route.name) > -1
      },

      ...mapState([ 'title', 'description', 'ready', 'imgReady' ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue